import { createFileRoute } from '@tanstack/react-router'

import { BillingUserInfoType } from '@/types/billing'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import BillingUserInfoForm from '@/components/forms/billing-user-info-form'
import { Header } from '@/components/header'

export const Route = createFileRoute(
  '/_home/user-role-management/billing-user-info/edit',
)({
  component: EditBillingUserInfo,
})

export default function EditBillingUserInfo({
  billingUserInfo,
  setShowEditBillingUserInfoModal,
}: {
  billingUserInfo: BillingUserInfoType
  setShowEditBillingUserInfoModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <>
      <main>
        <CredenzaContent className="flex w-full max-w-[750px] justify-center">
          <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
            <Header
              subroutes={[
                {
                  route: '/user-role-management/billing-user-info',
                  label: 'Billing User Info',
                },
              ]}
            >
              Edit Billing User Info
            </Header>
            <BillingUserInfoForm
              setShowEditBillingUserInfoModal={setShowEditBillingUserInfoModal}
              billingUserInfo={billingUserInfo}
            />
          </CredenzaBody>
        </CredenzaContent>
      </main>
    </>
  )
}
